import type { FaireProductEntity } from "../../entity_types/product";

export const p_s6csnqba9q: FaireProductEntity = {
  token: "p_s6csnqba9q",
  type: "product",
  name: "2026 Solid Color Cropped Tank Top and Jogger Pants Set",
  brandToken: "b_uerhe9978w",
  brandName: "fashionworks",
  imageUrl:
    "https://cdn.faire.com/fastly/5e7ec3547a561e4a2c296fc0f3acc94923c301a1e8e18726459141f5e69fe6d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18c464ba24e6e62871127597a3c931a97aacc390996ff109a7a61ea8cddab17f.jpeg",
    "https://cdn.faire.com/fastly/537c75b2f7b96601268b6e9e52545685e0984f36054564874eea0772b32e4d87.jpeg",
    "https://cdn.faire.com/fastly/7a0f395b602ca313635bd5d8ee9cf8fc10106530ada369ca282ab1c16518bf2d.png",
  ],
  priceDollars: 29.5,
  description:
    "🌺Material: 95%Cotton+5%Elastane\n🌺Pattern: Solid\n🌺Neckline: Round Neck\n🌺Sleeve: Sleeveless\n🌺Details: Decoration\n\n\n\n2026 Solid Color Cropped Tank Top and Jogger Pants Set\n",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:30.508Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
